import React, { useRef } from 'react'
import { Grid, Hidden, Typography } from '@mui/material'
import MapComponents from 'view/Map/MapComponents';
import { InfoWindow, Marker } from '@react-google-maps/api';
import { OpenNewTab } from 'utilities/utilities';

const Footer = ({ isMap = false }) => {
    const mapReFooter = useRef(null);

    return (
        <React.Fragment>
            {isMap && <MapComponents
                id={"map-footer"}
                mapRef={mapReFooter}
                IsMultiMarker={false}
                Isdisable={true}
                IsMarker={false}
                IsPopUp={true}
                IsSearch={false}
                IsDefaultThai={false}
                nZoomClick={14}
                markerSearch={{
                    lat: 13.762249,
                    lng: 100.527675,
                }}
                IsDefaultCustomPopup={true}
            />}
            {/* normal size */}
            <Hidden smDown>
                <div className='session-footer'>
                    <Typography>
                        สงวนลิขสิทธิ์ตามพระราชบัญญัติลิขสิทธิ์โดย<br />
                        <span>กองทุนจัดการซากดึกดำบรรพ์</span><br />
                        <span>กองคุ้มครองซากดึกดำบรรพ์</span>
                    </Typography>
                </div>
            </Hidden>
            {/* phone size */}
            <Hidden smUp>
                <div className='session-footer-phone'>
                    <Typography>
                        สงวนลิขสิทธิ์ตามพระราชบัญญัติลิขสิทธิ์โดย<br />
                        <span>กองทุนจัดการซากดึกดำบรรพ์</span><br />
                        <span>กองคุ้มครองซากดึกดำบรรพ์</span>
                    </Typography>
                </div>
            </Hidden>
        </React.Fragment>
    )
}

export default Footer
